import React from 'react';
import CatalogHomeTemplate from '../components_catalog/template/catalogHomeTemplate';


class catalogHome extends React.Component {

    render() {
        return (
            <CatalogHomeTemplate />
        )
    }
}
export default catalogHome;